import moment from "moment"
import MessageDilog from "../../components/MessageDilog"
import { SNACK_BAR_VARIETNS, actions } from "../../utils/constants"
import { callApiAction } from "./commonAction"
import { openModal } from "./modalAction"
import { fetchHolidays } from "../../apis/holiday.api"
import { callSnackBar } from "./snackbarAction"

export const fetchHolidayListAction = () => {
    return async (dispatch, getState) => {

        dispatch({ type: actions.START_HOLIDAY_COUNT_LOADING })

        dispatch(callApiAction(
            async () => await fetchHolidays({ date: moment().toISOString() }),
            (response) => {
                if (response )
                    dispatch({ type: actions.SET_HOLIDAY_COUNT_DATA, value: response })

            },
            (err) => {
                dispatch(callSnackBar("Something went wrong",SNACK_BAR_VARIETNS.error))
                //dispatch(openModal({component:<MessageDilog title="Something went wrong" message={err} />,size:"md"}))
            }
        ))
    }
}

